import React from 'react';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';

import * as actions from './store/displayProductActions';
import * as action from '../../np-core/Auth/store/authActions';
import DisplayProductList from './DisplayProductList';
import { Fab } from '@material-ui/core';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    fab: {
        right: 5,
        bottom: 5,
        position: 'fixed',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    }
});

const DisplayProduct = props => {
    const { classes, displayProducts, activeCustomer } = props;
    return (
        <div className={classes.root}>
            <DisplayProductList activeCustomer={activeCustomer} columnsState={props.columns} saveColumnsFilter={props.saveColumnsFilter} displayProducts={displayProducts} onFetchDisplayProducts={props.onFetchDisplayProducts} />
            <Fab color="primary" aria-label="Add" className={classes.fab} style={{ borderRadius: '1px' }}>
                <AddIcon />
            </Fab>
        </div>

    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        displayProducts: state.product.displayProducts,
        columns: state?.core?.login?.userSetting?.columns
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchDisplayProducts: filter => dispatch(actions.fetchDisplayProduct(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data))
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DisplayProduct));